import React, { Fragment, useEffect, useState } from 'react';

import { Box } from '@mui/material';
import Handlebars from 'handlebars';
import moment from 'moment-timezone';

import { getDotColor } from '../../utils/events';
import {
  capitalizeText,
  convertMeterToMileString,
  convertSecondToHour,
  formatDateTime,
  lowerCase,
  removeDash,
  renderLocation,
  replaceDash,
  splitText,
  upperCase,
  when,
  whenAnd,
  whenOr,
  replaceText,
  sum,
  parseJSON,
  toJSON,
} from '../../utils/handlebars';
import { sanitizeHtml } from '../../utils/sanitization';
import HistoryEventJson from '../EventTemplates/HistoryEventJson';
import styles from './styles';

const customFunctions = [
  {
    func: renderLocation,
    name: 'renderLocation',
  },
  {
    func: lowerCase,
    name: 'lowerCase',
  },
  {
    func: upperCase,
    name: 'upperCase',
  },
  {
    func: removeDash,
    name: 'removeDash',
  },
  {
    func: replaceDash,
    name: 'replaceDash',
  },
  {
    func: convertMeterToMileString,
    name: 'convertMeterToMileString',
  },
  {
    func: convertSecondToHour,
    name: 'convertSecondToHour',
  },
  {
    func: capitalizeText,
    name: 'capitalizeText',
  },
  {
    func: splitText,
    name: 'splitText',
  },
  {
    func: formatDateTime,
    name: 'formatDateTime',
  },
  {
    func: when,
    name: 'when',
  },
  {
    func: whenAnd,
    name: 'whenAnd',
  },
  {
    func: whenOr,
    name: 'whenOr',
  },
  {
    func: replaceText,
    name: 'replaceText',
  },
  {
    func: sum,
    name: 'sum',
  },
  {
    func: parseJSON,
    name: 'parseJSON',
  },
  {
    func: toJSON,
    name: 'toJSON',
  },
];

customFunctions.map((func) => Handlebars.registerHelper(func.name, func.func));

function DecoratedEvent({ eventMap, isWithoutSecond = false }) {
  const [isShowModal, setIsShowModal] = useState(false);
  const [originViewMode, setOriginViewMode] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const onViewDetail = (e) => {
    setIsShowModal(true);
    setSelectedEvent(e);
  };

  const handleToggleModal = (v) => {
    setIsShowModal(v);
  };

  const onViewMode = (key) => {
    if (originViewMode) {
      setOriginViewMode(false);
      setSelectedEvent(eventMap.get(key).converted);
    } else {
      setOriginViewMode(true);
      setSelectedEvent(eventMap.get(key).origin);
    }
  };

  if (!eventMap || eventMap.size === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: 'AvenirNext',
          fontWeight: 500,
          fontSize: 16,
        }}
      >
        No history
      </Box>
    );
  }

  return (
    <Fragment>
      <div style={styles.innerItems}>
        <div style={styles.line}></div>
        {Array.from(eventMap.values()).map(({ origin, converted, template }, idx) => {
          if (converted.date) {
            return (
              <div style={styles.item} key={`${converted.date}-${idx}`}>
                <Box sx={{ display: 'flex' }}>
                  <div style={{ flex: 1, position: 'relative' }}>
                    <div style={styles.lineDate} />
                  </div>
                  <div style={{ width: 200, textAlign: 'center' }}>
                    <span style={styles.date}>{converted.date}</span>
                  </div>
                  <div style={{ flex: 1, position: 'relative' }}>
                    <div style={styles.lineDate} />
                  </div>
                </Box>
              </div>
            );
          } else {
            let compileContent = Handlebars.compile(template.content);
            const rendered = compileContent({ ...converted, ...origin });

            return (
              <div style={styles.item} key={`${converted.id}-${idx}`}>
                <div style={styles.inner} className="item">
                  <div
                    data-testid="viewDetail"
                    style={{
                      ...styles.car,
                      backgroundColor: getDotColor(template.color, origin) || '#ccc',
                    }}
                    onClick={() => onViewDetail(origin)}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      flex: 1,
                      justifyContent: 'space-between',
                      fontSize: 12,
                      fontFamily: 'AvenirNext',
                      color: 'rgb(74,74,74)',
                      lineHeight: 1.7,
                      wordBreak: 'normal',
                      overflowWrap: 'anywhere',
                    }}
                  >
                    <div style={styles.notes} dangerouslySetInnerHTML={{ __html: sanitizeHtml(rendered) }} data-testid="event-content" />
                    {isWithoutSecond && origin.ts && <div style={styles.time}>{moment.tz(origin.ts, moment.tz.guess()).format('hh:mm A z')}</div>}
                    {!isWithoutSecond && origin.ts && <div style={styles.time}>{moment.tz(origin.ts, moment.tz.guess()).format('HH:mm:ss A z')}</div>}
                  </Box>
                </div>
              </div>
            );
          }
        })}
      </div>
      <HistoryEventJson
        isShowModal={isShowModal}
        event={selectedEvent}
        handleToggleModal={(v) => handleToggleModal(v)}
        originViewMode={originViewMode}
        onViewMode={onViewMode}
        setOriginViewMode={setOriginViewMode}
      />
    </Fragment>
  );
}

export default DecoratedEvent;
